import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";

export default function UserActivityTracker() {
  return (
    <Card>
      <CardHeader><CardTitle>User Activity Tracker</CardTitle><CardDescription>Monitor user sessions and login activity</CardDescription></CardHeader>
      <CardContent><div className="py-8 text-center text-muted-foreground">User activity tracking requires a backend Analytics API. Coming soon.</div></CardContent>
    </Card>
  );
}
